import { render, staticRenderFns } from "./TabSolenoid.vue?vue&type=template&id=247a2108&"
import script from "./TabSolenoid.vue?vue&type=script&lang=js&"
export * from "./TabSolenoid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports